<p-dialog
  [(visible)]="visible"
  (onHide)="onHide()"
  [header]="'APP_INFO.DIALOG_ARIA_LABEL' | translate"
  [style]="{ width: '85vw', height: '85vh' }"
  [maximizable]="true"
  [closeAriaLabel]="'ACCESSIBILITY.BUTTONS.CLOSE.ARIA_LABEL' | translate"
  [modal]="true">
  <ng-template #header let-ariaLabelledBy="ariaLabelledBy">
    <h2 [id]="ariaLabelledBy" class="app-info-dialog-title">{{ 'APP_INFO.DIALOG_ARIA_LABEL' | translate }}</h2>
    <div class="app-info-nav">
      @for (item of items; track item.id) {
        <a
          [class.active]="activeItemId === item.id"
          [attr.data-testid]="'app-info-nav-' + item.id"
          [attr.aria-current]="activeItemId === item.id ? 'true' : null"
          [href]="'#' + item.id + '-anchor'"
          (click)="$event.preventDefault(); onActiveItemChange(item.id)">{{ item.label }}</a>
      }
    </div>
  </ng-template>

  <div
    class="app-info-container"
    citoDoeScrollSpy
    [spiedTags]="['SECTION']"
    (sectionChange)="onSectionChange($event)"
    style="height: 100%; overflow-y: scroll">
    <section id="welkom-anchor">
      <h3 data-testid="info-section-welkom">{{ 'APP_INFO.WELKOM.SECTION_TITLE' | translate }}</h3>
      <p data-testid="info-welkom-paragraph" [innerHTML]="'APP_INFO.WELKOM.CONTENT_P1' | translate"></p>
      <p data-testid="info-welkom-link-doe-website" [innerHTML]="'APP_INFO.WELKOM.CONTENT_P2' | translate"></p>
      <p data-testid="info-welkom-link-handleidingen" [innerHTML]="'APP_INFO.WELKOM.CONTENT_P3' | translate"></p>
      <p [innerHTML]="'APP_INFO.WELKOM.CONTENT_P4' | translate"></p>
    </section>

    <section id="hoe-anchor">
      <h3 data-testid="info-section-hoe-werkt">{{ 'APP_INFO.HOE_HET_WERKT.SECTION_TITLE' | translate }}</h3>
      <p [innerHTML]="'APP_INFO.HOE_HET_WERKT.CONTENT_P1' | translate"></p>
      <p [innerHTML]="'APP_INFO.HOE_HET_WERKT.CONTENT_P2' | translate"></p>
      <p [innerHTML]="'APP_INFO.HOE_HET_WERKT.CONTENT_P3' | translate"></p>
    </section>

    @if (appVariant() === AppVariants.DOE) {
      <section id="datums-anchor" data-testid="section-container-belangrijke-data">
        <h3 data-testid="table-important-dates-title" data-testid="section-toggle-belangrijke-data">
          {{ 'APP_INFO.IMPORTANT_DATES.TITLE' | translate }}
          <span>{{ (settingsPeriods$ | async)?.['campagneJaar']?.startDate | date: 'yyyy' : 'UTC' }}</span>
          <span>/{{ (settingsPeriods$ | async)?.['campagneJaar']?.endDate | date: 'yyyy' : 'UTC' }} </span>
        </h3>
        <p data-testid="table-important-dates-title">{{ 'APP_INFO.IMPORTANT_DATES.CONTENT_P1' | translate }}</p>

        <table class="table-important-dates" data-testid="table-important-dates" data-testid="table-belangrijke-data">
          <tbody>
            <tr>
              <td
                [innerHTML]="
                  'APP_INFO.IMPORTANT_DATES.TABLE.ROW_1_COL_1'
                    | translate
                      : { datumVanaf: (settingsPeriods$ | async)?.['inschrijving']?.startDate | date: 'd MMMM' : 'UTC' }
                "></td>
              <td [innerHTML]="'APP_INFO.IMPORTANT_DATES.TABLE.ROW_1_COL_2' | translate"></td>
            </tr>
            <tr>
              <td
                [innerHTML]="
                  'APP_INFO.IMPORTANT_DATES.TABLE.ROW_2_COL_1'
                    | translate
                      : {
                          datumVanaf:
                            (settingsPeriods$ | async)?.['handmatigeInvoerDeelnemers']?.startDate
                            | date: 'd MMMM' : 'UTC',
                        }
                "></td>
              <td [innerHTML]="'APP_INFO.IMPORTANT_DATES.TABLE.ROW_2_COL_2' | translate"></td>
            </tr>
            <tr>
              <td
                [innerHTML]="
                  'APP_INFO.IMPORTANT_DATES.TABLE.BRAILLE_SLECHTZIEND_UITERSTE_BESTELDATUM_DATE'
                    | translate
                      : {
                          datumVanaf:
                            (settingsPeriods$ | async)?.['plannenPapierDichtzetten']?.startDate
                            | date: 'd MMMM' : 'UTC',
                        }
                "></td>
              <td
                [innerHTML]="
                  'APP_INFO.IMPORTANT_DATES.TABLE.BRAILLE_SLECHTZIEND_UITERSTE_BESTELDATUM_TEXT' | translate
                "></td>
            </tr>
            <tr>
              <td
                [innerHTML]="
                  'APP_INFO.IMPORTANT_DATES.TABLE.ROW_3_COL_1'
                    | translate
                      : {
                          datumVanaf:
                            (settingsPeriods$ | async)?.['voorlopigSchooladvies']?.startDate | date: 'd MMMM' : 'UTC',
                          datumTot:
                            (settingsPeriods$ | async)?.['voorlopigSchooladvies']?.endDate | date: 'd MMMM' : 'UTC',
                        }
                "></td>
              <td [innerHTML]="'APP_INFO.IMPORTANT_DATES.TABLE.ROW_3_COL_2' | translate"></td>
            </tr>
            <tr>
              <td
                [innerHTML]="
                  'APP_INFO.IMPORTANT_DATES.TABLE.ROW_4_COL_1'
                    | translate
                      : {
                          datumVanaf: (settingsPeriods$ | async)?.['regulier']?.startDate | date: 'd MMMM' : 'UTC',
                          datumTot: (settingsPeriods$ | async)?.['regulier']?.endDate | date: 'd MMMM' : 'UTC',
                        }
                "></td>
              <td [innerHTML]="'APP_INFO.IMPORTANT_DATES.TABLE.ROW_4_COL_2' | translate"></td>
            </tr>
            <tr>
              <td
                [innerHTML]="
                  'APP_INFO.IMPORTANT_DATES.TABLE.ROW_5_COL_1'
                    | translate
                      : {
                          datumVanaf: (settingsPeriods$ | async)?.['inhaal']?.startDate | date: 'd MMMM' : 'UTC',
                          datumTot: (settingsPeriods$ | async)?.['inhaal']?.endDate | date: 'd MMMM' : 'UTC',
                        }
                "></td>
              <td [innerHTML]="'APP_INFO.IMPORTANT_DATES.TABLE.ROW_5_COL_2' | translate"></td>
            </tr>
            <tr>
              <td
                [innerHTML]="
                  'APP_INFO.IMPORTANT_DATES.TABLE.ROW_6_COL_1'
                    | translate
                      : {
                          datumVanaf:
                            (settingsPeriods$ | async)?.['rapportagesBeschikbaar']?.startDate | date: 'd MMMM' : 'UTC',
                        }
                "></td>
              <td [innerHTML]="'APP_INFO.IMPORTANT_DATES.TABLE.ROW_6_COL_2' | translate"></td>
            </tr>
            <tr>
              <td
                [innerHTML]="
                  'APP_INFO.IMPORTANT_DATES.TABLE.ROW_7_COL_1'
                    | translate
                      : { datumVanaf: (settingsPeriods$ | async)?.['schooladvies']?.endDate | date: 'd MMMM' : 'UTC' }
                "></td>
              <td [innerHTML]="'APP_INFO.IMPORTANT_DATES.TABLE.ROW_7_COL_2' | translate"></td>
            </tr>
            <tr>
              <td
                [innerHTML]="
                  'APP_INFO.IMPORTANT_DATES.TABLE.ROW_8_COL_1'
                    | translate
                      : {
                          datumVanaf: (settingsPeriods$ | async)?.['aanmeldenVO']?.startDate | date: 'd MMMM' : 'UTC',
                          datumTot: (settingsPeriods$ | async)?.['aanmeldenVO']?.endDate | date: 'd MMMM' : 'UTC',
                        }
                "></td>
              <td [innerHTML]="'APP_INFO.IMPORTANT_DATES.TABLE.ROW_8_COL_2' | translate"></td>
            </tr>

            @if (
              ('APP_INFO.IMPORTANT_DATES.TABLE.ROW_9_COL_1' | translate) !==
              'APP_INFO.IMPORTANT_DATES.TABLE.ROW_9_COL_1'
            ) {
              <tr>
                <td [innerHTML]="'APP_INFO.IMPORTANT_DATES.TABLE.ROW_9_COL_1' | translate"></td>
                <td [innerHTML]="'APP_INFO.IMPORTANT_DATES.TABLE.ROW_9_COL_2' | translate"></td>
              </tr>
            }
          </tbody>
        </table>
      </section>
    }
    <!-- DOEDST-->

    <section id="contact-anchor">
      <h3 data-testid="info-section-contact">{{ 'APP_INFO.CONTACT.SECTION_TITLE' | translate }}</h3>
      <p data-testid="info-contact-link-email" [innerHTML]="'APP_INFO.CONTACT.CONTENT_P1' | translate"></p>
      <p [innerHTML]="'APP_INFO.CONTACT.CONTENT_P2' | translate"></p>
      <p [innerHTML]="'APP_INFO.CONTACT.CONTENT_P3' | translate"></p>
    </section>
  </div>

  <ng-template #footer>
    <button type="button" pButton
      data-testid="toets-info-dialog-ok-button"
      class="p-button-rounded"
      (click)="closeAppInfo()">{{ 'OKE' | translate }}</button>
  </ng-template>
</p-dialog>
